import {
  applySnapshot,
  getSnapshot,
  Instance,
  SnapshotIn,
  types,
} from 'mobx-state-tree';
import { LoadingState, LoadingStates } from 'globals/types';
import { temporaryEndpoints } from 'http/endpoints';
import { isStoreInitialized, performSetAction } from 'models/utils/utils';
import { Notification, NotificationProps } from './notification/notification';

export interface NotificationsProps {
  data: NotificationProps[];
  status: LoadingState;
}

export const Notifications = types
  .model({
    data: types.optional(types.array(Notification), []),
    status: types.optional(
      types.enumeration(LoadingStates),
      LoadingState.INITIAL
    ),
  })
  .actions((self) => ({
    set(props: NotificationsProps): void {
      applySnapshot(self, {
        ...getSnapshot(self),
        ...props,
      });
    },
    updateStatus(status: LoadingState): void {
      applySnapshot(self, {
        ...getSnapshot(self),
        status,
      });
    },
  }))
  .actions((self) => ({
    async setStore(): Promise<void> {
      await performSetAction({
        store: self,
        endpoint: temporaryEndpoints.notifications,
      });
    },
  }))
  .actions((self) => ({
    async init(): Promise<void> {
      const { status } = getSnapshot(self);
      if (isStoreInitialized(status)) return;
      await self.setStore();
    },
    async update(): Promise<void> {
      await self.setStore();
    },
  }))
  .views((self) => ({
    getNotificationList(): NotificationProps[] {
      const { data } = self;
      return [...getSnapshot(data)];
    },
  }));

export const notifications = Notifications.create();
export type NotificationsSnapshot = SnapshotIn<typeof Notifications>;
export type NotificationsInstance = Instance<typeof Notifications>;
export default notifications;
